import React from 'react';

const FEATURE_GRAPHIC = '/AutoRaja_FeatureGraphic_With_Title_1794x877.png';

const LINKS = [
  { path: '/autoraja', label: 'Overview', route: 'autoraja' },
  { path: '/autoraja/support', label: 'Support', route: 'autoraja-support' },
  { path: '/autoraja/privacy', label: 'Privacy', route: 'autoraja-privacy' },
  { path: '/autoraja/delete-data', label: 'Data Deletion', route: 'autoraja-delete-data' },
  { path: '/autoraja/credits', label: 'Credits', route: 'autoraja-credits' },
];

const AutoRajaPageNav = ({ route, navigateToPath }) => (
  <div className="autoraja-page-top">
    <figure className="autoraja-feature-poster">
      <img
        src={FEATURE_GRAPHIC}
        alt="AutoRaja feature graphic poster"
        className="autoraja-feature-poster-image"
      />
    </figure>
    <nav className="autoraja-subnav" aria-label="AutoRaja sections">
      {LINKS.map((link) => {
        const isActive = link.route === route;
        return (
          <a
            key={link.path}
            href={link.path}
            aria-current={isActive ? 'page' : undefined}
            className={`autoraja-subnav-link${isActive ? ' is-active' : ''}`}
            onClick={(event) => {
              event.preventDefault();
              navigateToPath(link.path);
            }}
          >
            {link.label}
          </a>
        );
      })}
    </nav>
  </div>
);

export default AutoRajaPageNav;
